/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { Animal } from '../models/animal';
import { ArgusAnimal } from '../models/argus-animal';
import { createCustomer } from '../fn/customer/create-customer';
import { CreateCustomer$Params } from '../fn/customer/create-customer';
import { Customer } from '../models/customer';
import { CustomerDetail } from '../models/customer-detail';
import { CustomerTerms } from '../models/customer-terms';
import { findCustomers } from '../fn/customer/find-customers';
import { FindCustomers$Params } from '../fn/customer/find-customers';
import { findTermsAndConditions } from '../fn/customer/find-terms-and-conditions';
import { FindTermsAndConditions$Params } from '../fn/customer/find-terms-and-conditions';
import { getAnimalsForCustomer } from '../fn/customer/get-animals-for-customer';
import { GetAnimalsForCustomer$Params } from '../fn/customer/get-animals-for-customer';
import { getArgusAnimals } from '../fn/customer/get-argus-animals';
import { GetArgusAnimals$Params } from '../fn/customer/get-argus-animals';
import { getCustomerById } from '../fn/customer/get-customer-by-id';
import { GetCustomerById$Params } from '../fn/customer/get-customer-by-id';
import { getMedicalHistoryCustomerById } from '../fn/customer/get-medical-history-customer-by-id';
import { GetMedicalHistoryCustomerById$Params } from '../fn/customer/get-medical-history-customer-by-id';
import { inactivateCustomer } from '../fn/customer/inactivate-customer';
import { InactivateCustomer$Params } from '../fn/customer/inactivate-customer';
import { MhCustomer } from '../models/mh-customer';
import { modifyCustomer } from '../fn/customer/modify-customer';
import { ModifyCustomer$Params } from '../fn/customer/modify-customer';
import { modifyCustomerAnimals } from '../fn/customer/modify-customer-animals';
import { ModifyCustomerAnimals$Params } from '../fn/customer/modify-customer-animals';
import { reactivateCustomer } from '../fn/customer/reactivate-customer';
import { ReactivateCustomer$Params } from '../fn/customer/reactivate-customer';

@Injectable({ providedIn: 'root' })
export class CustomerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getCustomerById()` */
  static readonly GetCustomerByIdPath = '/api/customers/{id}';

  /**
   * Returns the customer information with animals and detailed information
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCustomerById()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCustomerById$Response(params: GetCustomerById$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomerDetail>> {
    return getCustomerById(this.http, this.rootUrl, params, context);
  }

  /**
   * Returns the customer information with animals and detailed information
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCustomerById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCustomerById(params: GetCustomerById$Params, context?: HttpContext): Observable<CustomerDetail> {
    return this.getCustomerById$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomerDetail>): CustomerDetail => r.body)
    );
  }

  /** Path part for operation `modifyCustomer()` */
  static readonly ModifyCustomerPath = '/api/customers/{id}';

  /**
   * Updates customer with the given id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `modifyCustomer()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  modifyCustomer$Response(params: ModifyCustomer$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return modifyCustomer(this.http, this.rootUrl, params, context);
  }

  /**
   * Updates customer with the given id
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `modifyCustomer$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  modifyCustomer(params: ModifyCustomer$Params, context?: HttpContext): Observable<void> {
    return this.modifyCustomer$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `createCustomer()` */
  static readonly CreateCustomerPath = '/api/customers/{id}';

  /**
   * Creates customer and animal(s)
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createCustomer()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createCustomer$Response(params: CreateCustomer$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return createCustomer(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates customer and animal(s)
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createCustomer$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createCustomer(params: CreateCustomer$Params, context?: HttpContext): Observable<void> {
    return this.createCustomer$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `reactivateCustomer()` */
  static readonly ReactivateCustomerPath = '/api/customers/{id}/reactivate';

  /**
   * Reactivate a customer with the given id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reactivateCustomer()` instead.
   *
   * This method doesn't expect any request body.
   */
  reactivateCustomer$Response(params: ReactivateCustomer$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return reactivateCustomer(this.http, this.rootUrl, params, context);
  }

  /**
   * Reactivate a customer with the given id
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reactivateCustomer$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reactivateCustomer(params: ReactivateCustomer$Params, context?: HttpContext): Observable<void> {
    return this.reactivateCustomer$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `inactivateCustomer()` */
  static readonly InactivateCustomerPath = '/api/customers/{id}/inactivate';

  /**
   * Inactivate a customer with the given id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `inactivateCustomer()` instead.
   *
   * This method doesn't expect any request body.
   */
  inactivateCustomer$Response(params: InactivateCustomer$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return inactivateCustomer(this.http, this.rootUrl, params, context);
  }

  /**
   * Inactivate a customer with the given id
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `inactivateCustomer$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  inactivateCustomer(params: InactivateCustomer$Params, context?: HttpContext): Observable<void> {
    return this.inactivateCustomer$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getAnimalsForCustomer()` */
  static readonly GetAnimalsForCustomerPath = '/api/customers/{id}/animals';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAnimalsForCustomer()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAnimalsForCustomer$Response(params: GetAnimalsForCustomer$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Animal>>> {
    return getAnimalsForCustomer(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAnimalsForCustomer$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAnimalsForCustomer(params: GetAnimalsForCustomer$Params, context?: HttpContext): Observable<Array<Animal>> {
    return this.getAnimalsForCustomer$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Animal>>): Array<Animal> => r.body)
    );
  }

  /** Path part for operation `modifyCustomerAnimals()` */
  static readonly ModifyCustomerAnimalsPath = '/api/customers/{id}/animals';

  /**
   * to create and update animals after matching with argus animals
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `modifyCustomerAnimals()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  modifyCustomerAnimals$Response(params: ModifyCustomerAnimals$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return modifyCustomerAnimals(this.http, this.rootUrl, params, context);
  }

  /**
   * to create and update animals after matching with argus animals
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `modifyCustomerAnimals$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  modifyCustomerAnimals(params: ModifyCustomerAnimals$Params, context?: HttpContext): Observable<void> {
    return this.modifyCustomerAnimals$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `findCustomers()` */
  static readonly FindCustomersPath = '/api/customers';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findCustomers()` instead.
   *
   * This method doesn't expect any request body.
   */
  findCustomers$Response(params?: FindCustomers$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Customer>>> {
    return findCustomers(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `findCustomers$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findCustomers(params?: FindCustomers$Params, context?: HttpContext): Observable<Array<Customer>> {
    return this.findCustomers$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Customer>>): Array<Customer> => r.body)
    );
  }

  /** Path part for operation `findTermsAndConditions()` */
  static readonly FindTermsAndConditionsPath = '/api/customers/{language}/terms-conditions';

  /**
   * Return terms and conditions by language
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findTermsAndConditions()` instead.
   *
   * This method doesn't expect any request body.
   */
  findTermsAndConditions$Response(params: FindTermsAndConditions$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CustomerTerms>>> {
    return findTermsAndConditions(this.http, this.rootUrl, params, context);
  }

  /**
   * Return terms and conditions by language
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `findTermsAndConditions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findTermsAndConditions(params: FindTermsAndConditions$Params, context?: HttpContext): Observable<Array<CustomerTerms>> {
    return this.findTermsAndConditions$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<CustomerTerms>>): Array<CustomerTerms> => r.body)
    );
  }

  /** Path part for operation `getMedicalHistoryCustomerById()` */
  static readonly GetMedicalHistoryCustomerByIdPath = '/api/customers/{id}/medical-history';

  /**
   * Returns the customer information with animals and discounts for medical history
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getMedicalHistoryCustomerById()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMedicalHistoryCustomerById$Response(params: GetMedicalHistoryCustomerById$Params, context?: HttpContext): Observable<StrictHttpResponse<MhCustomer>> {
    return getMedicalHistoryCustomerById(this.http, this.rootUrl, params, context);
  }

  /**
   * Returns the customer information with animals and discounts for medical history
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getMedicalHistoryCustomerById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMedicalHistoryCustomerById(params: GetMedicalHistoryCustomerById$Params, context?: HttpContext): Observable<MhCustomer> {
    return this.getMedicalHistoryCustomerById$Response(params, context).pipe(
      map((r: StrictHttpResponse<MhCustomer>): MhCustomer => r.body)
    );
  }

  /** Path part for operation `getArgusAnimals()` */
  static readonly GetArgusAnimalsPath = '/api/customers/{id}/argus/animals';

  /**
   * Returns the animal list from argus, if the vet has access to the farm
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getArgusAnimals()` instead.
   *
   * This method doesn't expect any request body.
   */
  getArgusAnimals$Response(params: GetArgusAnimals$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ArgusAnimal>>> {
    return getArgusAnimals(this.http, this.rootUrl, params, context);
  }

  /**
   * Returns the animal list from argus, if the vet has access to the farm
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getArgusAnimals$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getArgusAnimals(params: GetArgusAnimals$Params, context?: HttpContext): Observable<Array<ArgusAnimal>> {
    return this.getArgusAnimals$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ArgusAnimal>>): Array<ArgusAnimal> => r.body)
    );
  }

}
